import React, { useState } from 'react';
import { useOnce } from '@root/src/web/lib/useOnce';
import { pickMessage, } from '@root/src/web/lib/messagePicker';
import { ReaderRevenueEpic, canShow as canShowReaderRevenueEpic, } from './ReaderRevenueEpic';
const buildReaderRevenueEpicConfig = ({ isSignedIn, countryCode, contentType, sectionName, shouldHideReaderRevenue, isMinuteArticle, isPaidContent, tags, contributionsServiceUrl, }) => {
    return {
        candidate: {
            id: 'reader-revenue-banner',
            canShow: () => canShowReaderRevenueEpic({
                isSignedIn,
                countryCode,
                contentType,
                sectionName,
                shouldHideReaderRevenue,
                isMinuteArticle,
                isPaidContent,
                tags,
                contributionsServiceUrl,
            }),
            show: (meta) => () => {
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                return React.createElement(ReaderRevenueEpic, Object.assign({}, meta));
            },
        },
        timeoutMillis: null,
    };
};
export const SlotBodyEnd = ({ isSignedIn, countryCode, contentType, sectionName, shouldHideReaderRevenue, isMinuteArticle, isPaidContent, tags, contributionsServiceUrl, }) => {
    const [SelectedEpic, setSelectedEpic] = useState(null);
    useOnce(() => {
        const readerRevenueEpic = buildReaderRevenueEpicConfig({
            isSignedIn,
            countryCode,
            contentType,
            sectionName,
            shouldHideReaderRevenue,
            isMinuteArticle,
            isPaidContent,
            tags,
            contributionsServiceUrl,
        });
        const epicConfig = {
            candidates: [readerRevenueEpic],
            name: 'slotBodyEnd',
        };
        pickMessage(epicConfig)
            .then((PickedEpic) => setSelectedEpic(PickedEpic))
            .catch((e) => console.error(`SlotBodyEnd pickMessage - error: ${e}`));
    }, [isSignedIn, countryCode]);
    if (SelectedEpic) {
        return React.createElement(SelectedEpic, null);
    }
    return null;
};
